module.exports = __webpack_public_path__ + "img/stop.5d4a6492.svg";